export const appStyles = {
  isBold: { fontWeight: 700 },
  isNormalWeight: { fontWeight: 400 },
}
